// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { mergeWithCss } from "@vanmeter/XDL/Utilities/mergeWithCss";
import React, { useState } from "react";

interface OwnProps {
    leftTitle?: string;
    rightTitles?: string[];
    extendedStyles?: LinesHeaderStyles;
    showBorderTop?: boolean;
    showExtraCol?: boolean;
    extraColHeader?: string;
}

export interface LinesHeaderStyles {
    wrapper?: InjectableCss;
    itemDescription?: InjectableCss;
    rightSection?: InjectableCss;
    qty?: InjectableCss;
    extraCol?: InjectableCss;
    priceUnit?: InjectableCss;
    total?: InjectableCss;
}

export const linesHeaderStyles: LinesHeaderStyles = {};

const LinesHeader = ({
    leftTitle,
    rightTitles,
    extendedStyles,
    showBorderTop = true,
    showExtraCol,
    extraColHeader,
}: OwnProps) => {
    const [styles] = useState(() => mergeWithCss(linesHeaderStyles, extendedStyles));

    return (
        <StyledWrapper {...styles.wrapper} id="cartHeader" {...{ showBorderTop, showExtraCol }}>
            <StyledWrapper {...styles.itemDescription}>{translate(leftTitle || "")}</StyledWrapper>
            <StyledWrapper {...styles.priceUnit}>{translate(rightTitles?.[0] || "")}</StyledWrapper>
            <StyledWrapper {...styles.qty}>{translate(rightTitles?.[1] || "")}</StyledWrapper>
            {showExtraCol && <StyledWrapper {...styles.extraCol}>{translate(extraColHeader || "")}</StyledWrapper>}
            <StyledWrapper {...styles.total} {...{ showExtraCol }}>
                {translate(rightTitles?.[2] || "")}
            </StyledWrapper>
        </StyledWrapper>
    );
};

LinesHeader.defaultProps = {
    leftTitle: translate("Item Description"),
    rightTitles: ["Price/Unit", "QTY", "Total"],
    showExtraCol: false,
};

export default LinesHeader;
